@let data = aggregatedData();
<div class="summary-header-container">
  <div class="summary-header">
    <!-- Header Row -->
    <div class="tr layout-row layout-align-start-center">
      <div class="th text-ellipsis flex layout-row layout-align-start-center">
        <span class="column-header">{{ 'Agent' | translate }}</span>
      </div>
      <div class="th text-ellipsis col-summary-status layout-row layout-align-start-center">
        <span class="column-header">{{ 'Status' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-start-center">
        <span class="column-header">{{ 'Agent ID' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-start-center">
        <span class="column-header">{{ 'Tags' | translate }}</span>
      </div>
      <div class="th text-ellipsis col-territories flex layout-row layout-align-start-center">
        <span class="column-header">{{ 'Territories' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Distance' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Avg Speed' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Drive Time' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Service Time' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Admin Time' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'PTO' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Paid Time' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Stops' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Unpl. Stops' | translate }}</span>
      </div>
      <div class="th text-ellipsis flex layout-row layout-align-center-center">
        <span class="column-header">{{ 'Acn' | translate }}</span>
      </div>
    </div>

    <!-- Data Row -->
    <div class="tr tr-data layout-row layout-align-start-center">
      <div class="td text-ellipsis flex layout-row layout-align-start-center">
        <span class="br-body-2">{{ employee()?.name }}</span>
      </div>
      <div class="td text-ellipsis col-summary-status layout-row layout-align-start-center">
        @if (groupStatus()) {
          <bz-tag [tone]="groupStatus() | timecardStatusTone">{{ 'TIMECARD_GROUP_STATUS.' + groupStatus() | translate }}</bz-tag>
        }
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-start-center">
        <span class="br-body-2">{{ employee()?.employeeId || '-' }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-start-center">
        @if (employee()?.tags?.length) {
          <app-bringoz-tags [tags]="employee().tags"></app-bringoz-tags>
        } @else {
          <span class="br-body-2">-</span>
        }
      </div>
      <div class="td text-ellipsis col-territories flex layout-row layout-align-start-center">
        @if (branchReferences()?.length) {
          <branches-indicator [branches]="branchReferences()"></branches-indicator>
        } @else {
          <span class="br-body-2">-</span>
        }
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.totalDistance | bringozDistance:'---':true:2 }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.avgSpeed | bringozSpeed:'---':true }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.totalDriveTime | bringozDurationExact }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.totalServiceTime | bringozDurationExact }}</span>
      </div>
      <div *ngxPermissionsOnly="'timekeeping.timeCard.update'"
           class="td text-ellipsis admin-time-cell flex layout-row layout-align-center-center"
           appBringozIdGenerator="timecard-detail-admin-time-cell"
           [class.editable-cell]="canEditAdminTime()"
           (click)="onAdminTimeClick($event)">
        <span class="br-body-2">{{ data?.totalAdminTime | bringozTimeHHMM }}</span>
        @if (canEditAdminTime()) {
          <bz-icon class="edit-icon" size="sm" [icon]="icons.edit"></bz-icon>
        }
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.totalPto | bringozTimeHHMM }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.totalPaidTime | bringozDurationExact }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.totalStops }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        <span class="br-body-2">{{ data?.unplannedStops }}</span>
      </div>
      <div class="td text-ellipsis flex layout-row layout-align-center-center">
        @if (data?.acknowledged) {
          <bz-icon class="check-icon" [icon]="icons.check" [label]="'TIMECARD_SHIFT_STATUS.Acknowledged' | translate"></bz-icon>
        }
      </div>
    </div>
  </div>
</div>
